import { render, staticRenderFns } from "./PurchaseReceiving.vue?vue&type=template&id=0f6984d0"
import script from "./PurchaseReceiving.vue?vue&type=script&lang=js"
export * from "./PurchaseReceiving.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports